import React from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HOUSE_OWN } from "../../../../shared/const/data";

const HomeAddressSummary = ({ t }) => {
  const { homeAddress, mailingAddress, mailingAddressSame, houseOwnOrRent } =
    useSelector((state) => state?.app);

  return (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div className="col-xs-12">
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>{t("review_summary.home_information_section1")}</strong>
            </div>
            <div className="col-xs-12 col-md-6" style={{ padding: 0 }}>
              <div className="row">
                <div className="col-xs-12">{`${homeAddress?.streetAddress}, ${homeAddress?.apartment ? homeAddress?.apartment + ",": ""
                  }`}{`${homeAddress?.city}, ${homeAddress?.province}`}{", "}{`${homeAddress.postalCode}`}</div>
              </div>
            </div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>{t("review_summary.home_information_section1_1")}</strong>
            </div>
            <div className="col-xs-12 col-md-6" style={{ padding: 0 }}>
              <div className="row">
                <div className="col-xs-12">
                  {mailingAddressSame
                    ? t("review_summary.home_information_same")
                    : t("review_summary.home_information_different")}
                </div>
              </div>
            </div>
          </div>
          <hr />

          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>{t("review_summary.home_information_section2")}</strong>
            </div>
            <div className="col-xs-12 col-md-6" style={{ padding: 0 }}>
              {mailingAddress?.street && mailingAddress?.street.length > 3 && (
                <div className="row">
                  <div className="col-xs-12">{`${mailingAddress?.street}`} 
						  {", "}
                    {`${mailingAddress?.city}`}
                    {", "}
                    {`${mailingAddress?.provinceState}`}
						  {", "}
                    {`${mailingAddress?.postalCode}`}</div>
                </div>
              )}
              {(!mailingAddress?.street ||
                mailingAddress?.street.length < 3) && (
                  <div className="row">
                    <div className="col-xs-12">{`${homeAddress?.streetAddress}, ${homeAddress?.apartment ? homeAddress?.apartment + "," : ""
                      }`}{`${homeAddress?.city}, ${homeAddress?.province}`}{", "}{`${homeAddress.postalCode}`}</div>
                  </div>
                )}
            </div>
          </div>

          <hr />
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-xs-12 col-md-6">
              <strong>{t("review_summary.home_information_section3")}</strong>
            </div>
            <div className="col-xs-12 col-md-6">
              {houseOwnOrRent === HOUSE_OWN
                ? t("home_information.own_radio")
                : t("home_information.rent_radio")}
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(HomeAddressSummary);
